import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import styles from 'styles/jss/original/components/favorites/favoriteIdeaList';
import dummyImage from 'public/img/ui/loading-dummy.gif';
import FavoriteIdeaListItemContainer from '@/containers/favorites/FavoriteIdeaListItemContainer';
import { IIdea } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  ideaList: IIdea[];
  isLoading: boolean;
};

const FavoriteIdeaList: React.FC<ComponentProps> = ({ ideaList, isLoading }) => {
  const classes = useStyles();
  const renderContent = () => {
    if (isLoading) {
      return (
        <p className={classes.textWrapper}>
          <img src={dummyImage} alt='ローディング中' className={classes.imgLoading} />
        </p>
      );
    } else if (!isLoading && ideaList.length === 0) {
      return <p className={classes.textWrapper}>アイデアをお気に入り登録しましょう</p>;
    } else {
      return (
        <GridContainer>
          {ideaList.map((item, index) => {
            return (
              <FavoriteIdeaListItemContainer
                idea={item}
                key={`favorite-item-${index.toString()}`}
              />
            );
          })}
        </GridContainer>
      );
    }
  };

  return <div className={classes.section}>{renderContent()}</div>;
};

export default FavoriteIdeaList;
